import Splide from '@splidejs/splide';

export default class LAstCarousel extends HTMLElement {

    constructor() {
        super();
    }

    connectedCallback() {
        let splide = new Splide('#last-carousel', {
            type   : 'slide',
            perPage: 3,
            arrows: false,
            gap: "1rem",
            autoplay: true,
            rewind: true,
            arrow: true,
            padding: { left: '0.2rem', right: '1rem' },
            breakpoints: {
                720: {
                    perPage: 1,
                },
            }
        });
        splide.mount();

    }

}